// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__qNQ62","btn__icon":"Button_btn__icon__o0tif","btn__content":"Button_btn__content__PVf6R"};